import React from "react";
import { BrowserView, MobileOnlyView } from "react-device-detect";
import AppLayout from "../layout";
import { FormationMobile } from "./mobile/formation";

const Formation = () => {
  return (
    <AppLayout>
      <BrowserView>
        <div className="formation">
          <h1 className="title"> FORMATION </h1>
          <div className="content-for">
            <div className="line-center"></div>
            <OneFormation
              date="Juillet 2017"
              title="BACCALAURÉAT"
              school="Lycée Cherif Samsidine Aidara"
              site="Vélingara, Sénégal"
            />
            <OneFormation
              date="Nov. 2017 - Juin 2020"
              title="LICENCE EN INFORMATIQUE"
              school="UCAO SAINT MICHEL"
              site="Dakar, Sénégal"
            />
            <OneFormation
              date="Sep. 2021 - Fevrier 2022"
              title="FORMATION EN DEV. WEB/MOBILE"
              school="3FPT"
              site="Dakar, Sénégal"
            />
          </div>
        </div>
      </BrowserView>
      <MobileOnlyView>
        <FormationMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const OneFormation = ({ date, title, school, site }) => {
  return (
    <div className="one-formation ">
      <div className="block-header">
        <h1>{date}</h1>
      </div>
      <div className="block-deco">
        <div className="vertical"></div>
        <div className="horizontal"></div>
      </div>
      <div className="block-footer">
        <h1>{title}</h1>
        <h2>{school}</h2>
        <p>{site}</p>
      </div>
    </div>
  );
};

// const DecoLine = ({ number }) => {
//   let h = 15;
//   return [...Array(number).keys()].map((value, i) => {
//     let nh = h + 25;
//     h = nh;
//     return (
//       <div
//         key={i}
//         className="deco-line"
//         style={{ height: h, marginLeft: 1 }}
//       ></div>
//     );
//   });
// };

export default Formation;
